import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import OccurrenceManagementService from "services/OccurrenceManagementService";
import { fireToast } from "services/sweetAlertConfig";
import Button from "../../../../Button";
import NoPolicemanError from "../NoPolicemanError";
import * as S from "./styles";

export default function FinishTab() {
  const { occurrenceToEdit } = useManualOccurrence();

  const isReportWithoutPoliceman =
    !occurrenceToEdit.report ||
    (occurrenceToEdit.report && occurrenceToEdit.report.length === 0);

  async function handleFinishOccurrence() {
    const { id, policemen, report } = occurrenceToEdit;

    if (!report) return;

    const superficialPolicemanId =
      report[0].superficialPoliceman?.id ?? undefined;
    const policemanId =
      policemen && policemen.length > 0 ? policemen[0].policeman.id : undefined;

    const params = {
      occurrenceId: id,
      superficialPolicemanId,
      policemanId,
    };

    try {
      await OccurrenceManagementService.finishOccurrence(params);
      fireToast("Ocorrência finalizada com sucesso!");
      window.location.reload();
    } catch {
      fireToast("Não foi possível finalizar a ocorrência. Tente novamente.");
    }
  }

  const policemanId =
    occurrenceToEdit?.report?.[0]?.superficialPoliceman?.id ||
    occurrenceToEdit?.policemen?.[0]?.id;

  return (
    <S.Wrapper>
      {!policemanId && <NoPolicemanError />}

      {policemanId && (
        <>
          <S.Title>Finalizar o atendimento nessa ocorrência?</S.Title>

          <S.ConfirmationInfo>
            <p>
              Você está prestes a finalizar esse atendimento e declarar essa
              ocorrência como concluída. Essa ação irá:
            </p>
            <ul>
              <li>Remover a ocorrência da tela de monitoramento;</li>
              <li>Impedir que outros atendentes gerenciem os dados;</li>
              <li>
                Concluir o atendimento, registrando o procedimento gerenciado
                até o momento como finalizado.
              </li>
            </ul>
            <p>Deseja continuar?</p>
          </S.ConfirmationInfo>

          <Button
            title="Sim, finalizar ocorrência"
            disabled={isReportWithoutPoliceman}
            onClick={handleFinishOccurrence}
          />

          {isReportWithoutPoliceman && (
            <S.HelpText>
              * Você precisa associar um pronta-resposta primeiro antes de
              finalizar uma ocorrência em andamento.
            </S.HelpText>
          )}
        </>
      )}
    </S.Wrapper>
  );
}
